import { Features } from 'reducers/types';

export enum ScopeType {
  ORGANIZATION = 'organization',
  AGENCY = 'agency',
  USER = 'user',
}

const isFeatureEnabled = (
  featureFlag: Features,
  type: ScopeType,
  id: string,
) => {
  if (!featureFlag || featureFlag.scope?.type !== type) {
    return false;
  }

  const toIdArray = (value: unknown): string[] => {
    if (Array.isArray(value)) {
      return value.filter((item): item is string => typeof item === 'string');
    }

    if (typeof value === 'string' && value.trim() !== '') {
      return [value];
    }

    return [];
  };
  //p. need to verify valid featureflag content, complete.
  switch (type) {
    case ScopeType.USER:
      return featureFlag.scope.users?.includes(id) ?? false;
    case ScopeType.ORGANIZATION: {
      const organizationIds = toIdArray(featureFlag.scope.organization);

      if (organizationIds.length === 0) {
        return true;
      }

      return organizationIds.includes(id);
    }
    case ScopeType.AGENCY: {
      const agencyIds = toIdArray(featureFlag.scope.agencies);

      if (agencyIds.length === 0) {
        return true;
      }

      return agencyIds.includes(id);
    }
    default:
      return false;
  }
};

export default isFeatureEnabled;
